import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideZonelessChangeDetection,
} from '@angular/core';
import {
  provideRouter,
  withDisabledInitialNavigation,
  withEnabledBlockingInitialNavigation,
} from '@angular/router';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { BrowserUtils } from '@azure/msal-browser';
import {
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG,
  MsalBroadcastService,
  MsalGuard,
  MsalInterceptor,
  MsalService,
} from '@azure/msal-angular';
import { firstValueFrom } from 'rxjs';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import {
  MsalGuardFactory,
  MsalInstanceFactory,
  MsalInterceptorFactory,
} from './msal.config';

const initialNavigation =
  !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup()
    ? withEnabledBlockingInitialNavigation()
    : withDisabledInitialNavigation();

const authEnabled = (environment as any).msalConfig?.enabled !== false;

const authProviders = authEnabled
  ? [
      {
        provide: HTTP_INTERCEPTORS,
        useClass: MsalInterceptor,
        multi: true,
      },
      {
        provide: MSAL_INSTANCE,
        useFactory: MsalInstanceFactory,
      },
      {
        provide: MSAL_GUARD_CONFIG,
        useFactory: MsalGuardFactory,
      },
      {
        provide: MSAL_INTERCEPTOR_CONFIG,
        useFactory: MsalInterceptorFactory,
      },
      MsalService,
      MsalGuard,
      MsalBroadcastService,
      provideAppInitializer(() => {
        const msalService = inject(MsalService);
        return firstValueFrom(msalService.handleRedirectObservable());
      }),
    ]
  : [];

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(routes, initialNavigation),
    provideHttpClient(withInterceptorsFromDi()),
    ...authProviders,
  ],
};
